import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, ArrowRight } from "lucide-react";
import { BRAND } from "../lib/brand";

export default function Footer({ onGetQuote }) {
  return (
    <footer
      data-testid="site-footer"
      className="bg-wood-800 text-wood-100"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-8 py-14 lg:py-16">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3">
              <img
                src={BRAND.logoUrl}
                alt="Sylva King Plywood"
                className="h-14 w-14 object-contain rounded-sm"
              />
              <div>
                <div className="font-serif text-2xl">Sylva King</div>
                <div className="text-xs uppercase tracking-[0.3em] text-gold-400 font-bold">
                  Plywood
                </div>
              </div>
            </div>
            <p className="mt-6 text-sm leading-relaxed text-wood-200/80 max-w-sm">
              Premium plywood crafted for builders, architects and homeowners who
              never settle for ordinary.
            </p>

            <button
              data-testid="footer-get-quote-btn"
              onClick={onGetQuote}
              className="btn-primary mt-7 inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold"
            >
              Get a Quote <ArrowRight size={14} />
            </button>
          </div>

          <div className="lg:col-span-4">
            <div className="text-sm sm:text-base uppercase tracking-[0.18em] text-gold-400 font-bold">
              Navigate
            </div>
            <ul className="mt-6 grid grid-cols-2 gap-3 text-sm">
              <li><Link data-testid="footer-link-home" to="/" className="hover:text-gold-400 transition-colors">Home</Link></li>
              <li><Link data-testid="footer-link-about" to="/about" className="hover:text-gold-400 transition-colors">About Us</Link></li>
              <li><Link data-testid="footer-link-products" to="/products" className="hover:text-gold-400 transition-colors">Products</Link></li>
              <li><Link data-testid="footer-link-infrastructure" to="/infrastructure" className="hover:text-gold-400 transition-colors">Infrastructure</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-gold-400 transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-sm sm:text-base uppercase tracking-[0.18em] text-gold-400 font-bold">
              Reach Us
            </div>
            <ul className="mt-6 space-y-4 text-sm">
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-gold-400 shrink-0" />
                <a
                  data-testid="footer-email"
                  href={`mailto:${BRAND.email}`}
                  className="hover:text-gold-400 break-all"
                >
                  {BRAND.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-gold-400 shrink-0 mt-0.5" />
                <span data-testid="footer-address">{BRAND.address.full}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-5 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="text-xs text-wood-200/60">
            © {new Date().getFullYear()} Sylva King Plywood. All rights reserved.
          </div>
          <div className="text-xs text-wood-200/60 tracking-wider uppercase">
            Crafted with the strength of a king.
          </div>
        </div>
      </div>
    </footer>
  );
}
